export const sendTalkToSalesEvent = () => {
  if (window.ga) { 
    window.ga("send", {
      hitType: "event",
      eventCategory: "Homepage",
      eventAction: "Talk to Sales Request",
    })
  }
}